import type { CommonSVGProps } from './helpers';

export const CoinsIcon = ({ height = 32, stroke: strokeProp = '2', width = 32, ...props }: CommonSVGProps) => {
  const strokeWidth = typeof strokeProp === 'number' ? strokeProp : Number.parseFloat(String(strokeProp)) || 2;

  return (
    <svg fill="none" height={height} viewBox="0 0 21 21" width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.7492 8.6725C16.6157 8.99556 17.3868 9.5319 17.9911 10.2319C18.5954 10.932 19.0135 11.7731 19.2066 12.6775C19.3997 13.5819 19.3617 14.5204 19.096 15.4062C18.8303 16.292 18.3455 17.0965 17.6865 17.7453C17.0275 18.3941 16.2155 18.8663 15.3257 19.1181C14.4358 19.37 13.4968 19.3934 12.5955 19.1862C11.6943 18.979 10.8598 18.5478 10.1693 17.9327C9.47875 17.3175 8.9545 16.5381 8.645 15.6667M5.58333 4.66667H6.5V8.33333M14.4842 11.89L15.1258 12.5408L12.5408 15.1258M12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5Z"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
